import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import AdvertisementService from "./AdvertisementService";


export const getAdvertisements = createAsyncThunk("Advertisement/get-Advertisements", async (thunkAPI) => {
  try {
    return await AdvertisementService.getAdvertisements();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createAdvertisement = createAsyncThunk(
  "Advertisement/create-Advertisements",
  async (AssociationData, thunkAPI) => {
    try {
      return await AdvertisementService.createAdvertisement(AssociationData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getAdvertisement = createAsyncThunk(
  "Advertisement/get-Advertisement",
  async (id, thunkAPI) => {
    try {
      return await AdvertisementService.getAdvertisement(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateAdvertisement = createAsyncThunk(
  "Advertisement/update-Advertisement",
  async (id, thunkAPI) => {
    try {
      return await AdvertisementService.updateAdvertisement(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAdvertisement = createAsyncThunk(
  "Advertisement/delete-Advertisement",
  async (id, thunkAPI) => {
    try {
      return await AdvertisementService.deleteAdvertisement(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  Advertisements: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const AssociationSlice = createSlice({
  name: "Advertisement",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdvertisements.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAdvertisements.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Advertisements = action.payload.data;
      })
      .addCase(getAdvertisements.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createAdvertisement.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createAdvertisement.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdAdvertisement = action.payload;
      })
      .addCase(createAdvertisement.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })

      .addCase(getAdvertisement.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAdvertisement.fulfilled, (state, action) => {
        state.isLoading = false; 
        state.isError = false;
        state.isSuccess = true;
        state.Advertisementsplace = action.payload.data.place;
        console.log(action.payload.data.place);
        state.AdvertisementhitUrl = action.payload.data.hitUrl;
      })
      .addCase(getAdvertisement.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAdvertisement.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAdvertisement.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedAdvertisement = action.payload;
      })
      .addCase(updateAdvertisement.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAdvertisement.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAdvertisement.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedAdvertisement = action.payload;
      })
      .addCase(deleteAdvertisement.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default AssociationSlice.reducer;
